import { render, staticRenderFns } from "./ListRoles.vue?vue&type=template&id=71239e6f&"
import script from "./ListRoles.vue?vue&type=script&lang=js&"
export * from "./ListRoles.vue?vue&type=script&lang=js&"
import style0 from "./ListRoles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports